module.exports = __webpack_public_path__ + "img/subgroup_plus.9bb42662.svg";